import { COLORS } from 'helpers/globals'

const button = {
  background: COLORS.primary,
  color: 'white',
  fontSize: '1.8rem',
  fontWeight: '400',
  borderRadius: '1rem',
  padding: '.7rem 2.5rem',
  margin: '.5rem 0'
}

const topButton = {
  background: COLORS.primary,
  color: 'white',
  borderRadius: '1rem',
  padding: '.5rem 1.5rem'
}

const fovButton = {
  padding: '0 1rem',
  color: COLORS.primary,
  background: 'white',
  cursor: 'pointer',
  border: `1px solid ${COLORS.primary}`,
  '&:first-of-type': { borderRight: 0 }
}

export default {
  simulatedView: {
    flex: '0 0 auto',
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
    zIndex: 2,
    background: COLORS.secondary,
    color: 'white',
    alignItems: 'center'
  },
  topBar: {
    display: 'flex',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    width: '100%',
    margin: '.5rem 0',
    '& span': {
      fontSize: '1.8rem',
      fontWeight: '400'
    }
  },
  topButton,
  saveButton: {
    ...button,
    background: '#009e25'
  },
  fovButtonContainer: {
    flex: 1,
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '.5rem'
  },
  fovButton,
  fovButtonActive: {
    ...fovButton,
    background: COLORS.primary,
    color: 'white'
  },
  bottomRow: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    padding: '0 1rem'
  },
  backButton: {
    flex: 1,
    fontSize: '1.4rem',
    display: 'flex',
    alignItems: 'center'
  },
  backIcon: {
    fontSize: '1.2rem',
    marginRight: '.5rem'
  },
  changeButton: button
}



// WEBPACK FOOTER //
// ./src/components/BottomBar/SimulatedView/style.js